<div class="selector-container" [ngStyle]="{ 'width':width }">
  <div class="select-custom"
    [ngClass]="{ 'focused' : focused }"
    (mouseenter)="onMouseOver()"
    (mouseleave)="onMouseLeft()">
    @if (selectedIndex.length == 0) {
      <div class="selected-item placeholder"
        >
        {{ placeHolder }}
      </div>
    }
    @if (selectedIndex.length > 0) {
      <div class="selected-items"
        >
        @for (i of selectedIndex; track i) {
          <div>{{ items[i] }}
            <img src="assets/img/icons/cancel_white.png"
              alt="cancel-icon"
              (click)="removeItem(i)">
            </div>
          }
        </div>
      }
      <span class="arrow-down"
        (click)="toggleFocus()"
      [ngClass]="{ 'arrow-focused' : hovered || focused }"></span>
    </div>
    @if (focused) {
      <div class="select-custom-options"
        (mouseleave)="hideDropdown()"
        >
        @if (showSelectAll) {
          <div (click)="toggleSelectAll()">
            <input type="checkbox"
              class="checkbox"
              [(ngModel)]="selectAll"
              (ngModelChange)="onSelectAll()"/>
              <div>Select All</div>
            </div>
          }
          @for (i of items; track i; let index = $index) {
            <div (click)="onItemSelected(index)">
              <input type="checkbox"
                [checked]=" selectedIndex.includes(index)"/>
                <div>{{ i }}</div>
              </div>
            }
          </div>
        }
      </div>
